import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getHelpUrl } from '../../services/shared';

import ParameterControl from '../ParameterControl';
import { kassimBlue } from '../../style/theme';

const MainContainer = styled.div`
    padding-bottom: 16px;
    height: 100%;

    @media (max-width: 1200px) {
        /* max-width: 300px; */
        font-size: 90%;
    }
`;

const ContentPadding = styled.div`
    padding-left: 16px;
    padding-right: 16px;
`;
const ButtonContainer = styled(ContentPadding)`
    display: flex;
    margin-top: 16px;
    margin-bottom: 16px;
    height: 32px;

    & > * {
        margin-left: 16px;
    }

    & > *:first-child {
        margin-left: 0;
    }
`;

const ContentScrollContainer = styled(ContentPadding)`
    /* height: calc(100% - 72px);
    overflow-y: auto; */
`;

export const PanelTitle = styled.div`
    color: ${kassimBlue};
    padding: 0px 16px;
    border-bottom: 2px solid ${kassimBlue};
    font-weight: bold;
    font-size: 110%;
    height: 40px;
    line-height: 40px;
`;

const ExpansionPanel = styled(Accordion)`
    margin-top: 16px;
    background: #eee;
`;
const ExpansionPanelHeader = styled(AccordionSummary)`
    color: ${kassimBlue};
    font-weight: bold;
    padding-left: 4px;
    padding-right: 4px;

    & .MuiAccordionSummary-content {
        margin: 0;
    }
`;
const ExpansionDetails = styled(AccordionDetails)`
    padding-left: 4px;
    padding-right: 4px;
`;

const ParameterPanel = ({
    className,
    title,
    buttons,
    formValues = {},
    handleInputChange,
    language,
    gameConfig,
    readOnlyValues,
    readOnlyPanelTitle,
    variant = 'default',
}) => {
    return (
        <MainContainer className={className}>
            <PanelTitle>{title}</PanelTitle>
            <ButtonContainer>{buttons}</ButtonContainer>
            <ContentScrollContainer>
                {Object.entries(formValues).map(([key, value]) => {
                    const paramConfig = gameConfig[key];
                    let inputVal = value;
                    let helpUrl = getHelpUrl(
                        paramConfig.url,
                        gameConfig,
                        language
                    );
                    return (
                        <ParameterControl
                            key={key}
                            id={key}
                            variant={variant}
                            languageId={language}
                            {...paramConfig}
                            url={helpUrl}
                            hideCheckbox
                            value={inputVal}
                            onChange={handleInputChange(key, paramConfig)}
                        />
                    );
                })}

                {readOnlyValues && (
                    <ExpansionPanel>
                        <ExpansionPanelHeader
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="preset-parameters-content"
                            id="preset-parameters-header"
                        >
                            {readOnlyPanelTitle}
                        </ExpansionPanelHeader>
                        <ExpansionDetails>
                            <div>
                                {Object.entries(readOnlyValues).map(
                                    ([key, value]) => {
                                        const paramConfig = gameConfig[key];
                                        let inputVal = value;
                                        return (
                                            <ParameterControl
                                                key={key}
                                                id={key}
                                                languageId={language}
                                                {...paramConfig}
                                                hideCheckbox
                                                readonly={true}
                                                value={inputVal}
                                                onChange={handleInputChange(
                                                    key,
                                                    paramConfig
                                                )}
                                            />
                                        );
                                    }
                                )}
                            </div>
                        </ExpansionDetails>
                    </ExpansionPanel>
                )}
            </ContentScrollContainer>
        </MainContainer>
    );
};

export default ParameterPanel;
